module.exports = __webpack_public_path__ + "img/SetContribution.80fcf94f.jpg";